// core
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// services
import { environment } from '@open-portal-env';

import { PolicyDetailsService } from '@open-portal-app/core/services/policy-details.service';

@Component({
  selector: 'app-extra-details',
  templateUrl: './extra-details.component.html',
  styleUrls: ['./extra-details.component.scss']
})
export class ExtraDetailsComponent implements OnInit, AfterViewInit {
  extras!: Array<any>;
  apiEndpoint = environment.apiEndpoint;
  resizeListener!: any;

  @ViewChild('extrasContainer') extrasContainer!: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private policyDetailsService: PolicyDetailsService
  ) {}

  ngOnInit(): void {
    if (this.route.snapshot.data.extra) {
      this.extras = this.route.snapshot.data.extra;
    }
  }

  ngAfterViewInit() {
    this.setExtraBg();
    this.resizeListener = window.addEventListener('resize', () => {
      this.setExtraBg();
    });
  }

  ngOnDestroy(): void {
    if (this.resizeListener) {
      window.removeEventListener('resize', this.resizeListener);
    }
  }

  back() {
    this.router.navigate([`/policy/${this.route.snapshot.paramMap.get('productClass')}/${this.route.snapshot.paramMap.get('uuid')}`]);
  }

  setExtraBg() {
    if (this.extras && this.extras.length) {
      this.extras.forEach((extra: any, index: number) => {
        if (extra.type === 'banner') {
          let extraElement = this.extrasContainer.nativeElement.querySelectorAll('.extra-item > div > div')[index];

          if (extraElement) {
            if (extra.settings['image-desktop']) {
              extraElement.style.background = `linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%), url(${this.apiEndpoint + '/media/' + extra.settings['image-desktop']}) lightgray 50% / cover no-repeat`;
            }
            if (window.innerWidth < 1024 && extra.settings['image-mobile']) {
              extraElement.style.background = `linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%), url(${this.apiEndpoint + '/media/' + extra.settings['image-mobile']}) lightgray 50% / cover no-repeat`;
            }
          }
        }
      });
    }
  }

  goToDynamicSupportLink () {
    const extraInfoPage = this.route.snapshot.params.slug;
    if (this.route.snapshot.data.policy) {
      const extraInfo:any = Object.values(this.route.snapshot.data.policy?.extras || {})
        .find((extra: any) => extra.info_page === extraInfoPage);
      const dynamicSupportUrl = extraInfo?.external_data?.user_registration_link;
      if (dynamicSupportUrl) {
        window.open(dynamicSupportUrl, '_blank');
      }
    }
  }
}
